import { SearchCriteria } from 'src/app/core/interfaces/search-criteria.interface';
import { AppInterface } from '../../../interfaces/app.interface';
import { FIELD_PRIORITY_WEIGHT, SEARCH_FIELD, SearchPriorityConfig } from 'src/app/core/interfaces/search-priority-config';

export class AppTargetGoupsCriteria implements SearchCriteria {
  getMatchScore(_app: AppInterface, _query: string): number {
    return _app.targetGroups?.some(targetGroup => targetGroup.displayName.toLowerCase().includes(_query)) ? 1 : 0;
  }

  getRelevanceFieldWeightAndMatchScore(_app: AppInterface, _query: string): SearchPriorityConfig {
    return {
      relevanceField: SEARCH_FIELD.ORG_UNIT,
      fieldPriorityWeight: FIELD_PRIORITY_WEIGHT.ORG_UNIT,
      matchScore: this.getMatchScore(_app, _query),
    }
  }
}